export default __webpack_public_path__ + "static/media/Slide14.10626a38.jpg";